import DebugRow from 'features/debug/components/DebugRow'
import useOrderPayload from '@order/hooks/useOrderPayload'
import { useOrderState } from '@order/hooks/useOrderState'
import { useOrderConfigureState } from '@order/hooks/useOrderConfigureState'
import { ScrollView } from 'react-native'

export default function SummaryDebugView() {
  const { payload, error, guardMissing } = useOrderPayload()
  const result = useOrderState((s) => s.result)
  const submitError = useOrderConfigureState((s) => s.submitError)

  return (
    <ScrollView className="flex-1">
      {guardMissing && <DebugRow label="Guard Missing" value={guardMissing} />}
      {error && <DebugRow label="Payload Error" value={error} />}
      {submitError && <DebugRow label="Submit Error" value={submitError} />}
      <DebugRow label="Payload" value={payload} initialOpen={false} />
      <DebugRow label="Result" value={result} initialOpen={false} />
    </ScrollView>
  )
}
